import { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { roles, updateRole } from "../../../../store/roles_skills";

interface Props {
  isShown: boolean;
  role: roles;
  toggle: any;
}

type FormValues = {
  role: string;
  slug: string;
  description: string | null;
};

const EditRole = ({ isShown, role, toggle }: Props) => {
  const dispatch = useAppDispatch();
  const { register, handleSubmit, setValue } = useForm<FormValues>();

  const { status } = useAppSelector((state) => state.roles_skills);

  const onSubmit: SubmitHandler<FormValues> = async (data: any) => {
    dispatch(updateRole({ id_encrypted: role.id_encrypted, data: data }));
  };

  useEffect(() => {
    setValue("role", role.role);
    setValue("slug", role.slug);
    setValue("description", role.description);
  }, []);

  useEffect(() => {
    if (status === "updateRole_success" && isShown) {
      toggle();
    }
  }, [status]);

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="c-form-report"
        key={role.id}
        id={role.id_encrypted}
      >
        <div className="c-form-report__input-box" style={{ marginTop: "10px" }}>
          <span className="c-form-report__text-input">Role Name</span>
          <input
            type="text"
            className="c-form-report__input-value"
            style={{ color: "black" }}
            {...register("role")}
          />
        </div>

        <div className="c-form-report__input-box">
          <span className="c-form-report__text-input">Role Slug</span>

          <input
            type="text"
            className="c-form-report__input-value"
            style={{ color: "black" }}
            {...register("slug")}
          />
        </div>
        <div className="c-form-report__input-box">
          <span className="c-form-report__text-input">Role Description</span>
          <textarea
            className="c-form-report__input-value c-form-report__input-value--area"
            style={{ color: "black" }}
            {...register("description")}
          />
        </div>
        <div className="c-form-report__footer">
          <button type="submit" className="c-form-report__button-submit">
            Save Changes
          </button>
        </div>
      </form>
    </>
  );
};

export default EditRole;
